import Vue from 'vue'

Vue.filter('uploadurl', (val) => {
  return `${THAIRUNG.upload_url + val}`
})
